import React from 'react';
import Image from './Image';
import { imageWithIconDefaultProps, imageWithIconPropTypes } from '../propTypes';

/**
 * ImageWithIcon component renders an image with optional overlayed icon(s) or elements.
 *
 * @param {Object} props
 * @param {string} props.src - The image source URL.
 * @param {string} props.alt - The alt text for the image.
 * @param {string} [props.className] - Additional class names for the image.
 * @param {number} [props.height] - Image height.
 * @param {number} [props.width] - Image width.
 * @param {boolean} [props.lazy] - Whether to lazy load the image.
 * @param {React.ReactNode} [props.children] - Elements to overlay on the image.
 * @returns {JSX.Element}
 */
const ImageWithIcon = ({
  src,
  alt,
  className,
  height,
  width,
  lazy,
  children,
  ...rest
}) => {
  return (
    <div className="sui-relative sui-text-inverse">
      <Image
        src={src}
        alt={alt}
        className={className}
        height={height}
        width={width}
        lazy={lazy}
        {...rest}
      />
      <div className="sui-flex sui-justify-center sui-items-center sui-bg-inverse
        sui-absolute sui-inset-0 sui-m-auto sui-pointer-events-none sui-rounded-full
        sui-h-20 sui-w-20 sui-shadow-md"
      >
        {children}
      </div>
    </div>
  );
};

ImageWithIcon.propTypes = imageWithIconPropTypes;
ImageWithIcon.defaultProps = imageWithIconDefaultProps;

export default ImageWithIcon;